









































// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';
import {translateString} from "@/services/languageUtils";

const TIME = 2000;
const myInterval = 50;
const intervalTime = TIME / myInterval;
const intervalPercentage = 100 * intervalTime / TIME ;

@Component({
  name: 'DroppoHoldButton',
  components: {
  },
})
export default class DroppoHoldButton extends Vue {
  @Prop({ default: () => translateString('buttons.pressAndHold') })
  private readonly text!: string;

  @Prop({ default: false })
  private finishOpen!: boolean;

  private percentage: number = 0;
  private myInterval: number = 0;

  get loadingStyle() {
    return `width: ${this.percentage}%;`;
  }

  private start() {
    if (!this.finishOpen) {
      this.myInterval = setInterval(() => {
        if (this.percentage < 100) {
          this.percentage = this.percentage + intervalPercentage;
        } else {
          clearInterval(this.myInterval); // finish interval
        }

      }, intervalTime);
    }
  }

  private stop() {
    if (!this.finishOpen) {
      clearInterval(this.myInterval);

      if (this.percentage >= 100) {
        this.$emit('open');
      }

      this.percentage = 0;
    }
  }
}
